module.exports = __webpack_public_path__ + "images/comments-btns-center.5efad5ed.webp";